import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { AutomationWrapper } from './automation-details/AutomationWrapper'

const triggerBreadCrumbs: Array<PageLink> = [
  {
    title: 'Automations',
    path: '/automations',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AutomationPage = () => {
  return (
    <Routes>
     
      <Route index element={
            <>
              <PageTitle breadcrumbs={triggerBreadCrumbs}>Triggers list</PageTitle>
              <AutomationWrapper />
            </>
          } />
    </Routes>
  )
}

export default AutomationPage
